import { normalizeLinkPath, getTranslatedLink, ENGLISH_LOCALE, ChatAppSettings, useTranslation, SPANISH_LOCALE } from '@hfc/ui-core';

const toPath = (value: string): string => `/${normalizeLinkPath(value)}`;

// Spanish pages are resolved to their English counterpart through the same i18n link
// keys the language switcher uses, so blocking `/couple-health-plans` also blocks the corresponding spanish page
const getEnglishPath = (): string => toPath(getTranslatedLink(ENGLISH_LOCALE) ?? window.location.pathname);

const escapeRegexCharacters = (value: string): string => value.replace(/[.+?^${}()|[\]\\]/g, '\\$&');
const matchesUri = ({ currentPath, blockedUri }:{currentPath: string, blockedUri: string}): boolean => {
  const currentPathLower = currentPath.toLowerCase();
  const blockedUriLower = blockedUri.toLowerCase();

  const blockedPath = toPath(blockedUriLower);

  if (!blockedPath.includes('*')) {
    return currentPathLower === blockedPath;
  }

  const literalParts = blockedPath.split('*').map(escapeRegexCharacters);

  return new RegExp(`^${literalParts.join('.*')}$`).test(currentPathLower);
};

// For the seek of simplicity on HFC-7281 Im exporting this but we should create a new function useBlockedRoutes instead
export const isBlocked = (blockedUris: Array<string>): boolean => {
  const currentPath = getEnglishPath();

  return blockedUris.some(blockedUri => matchesUri({ currentPath, blockedUri }));
};

export const shouldShowWidget = ({ chatApp, isMobile }: {chatApp: ChatAppSettings | undefined, isMobile: boolean}): boolean => {
  if (!chatApp?.enabled) {
    return false;
  }
  if (!chatApp.showOnMobile && isMobile) {
    return false;
  }

  const isSpanish = useTranslation().locale.value === SPANISH_LOCALE;
  if (isSpanish && !chatApp.showOnSpanishPages) {
    return false;
  }

  return !isBlocked(chatApp.uris);
};
const WIDGET_ID = import.meta.env.VITE_APP_CHAT_APP_ID;
const WIDGET_HOST = import.meta.env.VITE_APP_CHAT_APP_HOST;
const WIDGET_CONNECTION_ID = import.meta.env.VITE_APP_CHAT_APP_CONNECTION_ID;
export const loadChatAppWidget = (): void => {
  if (document.getElementById(WIDGET_ID)) {
    return;
  }

  const widget = document.createElement('script');

  widget.src = `${WIDGET_HOST}/widget?connid=${WIDGET_CONNECTION_ID}`;
  widget.id = WIDGET_ID;
  widget.setAttribute('data-socket-uri', WIDGET_HOST);
  document.head.appendChild(widget);
};
